export const parseBranchAddress = (address, lat, lng) => {
    let street = "";
    let mapUrl = "";
    let provinceName = "";

    if (!address) {
        return {
            displayText: "",
            mapUrl: (lat && lng) ? `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}` : "",
        };
    }

    if (typeof address === "string") {
        if (address.includes('|')) {
            const parts = address.split('|');
            street = (parts[0] || "").trim();
            mapUrl = (parts.slice(1).join('|') || "").trim();
        } else {
            street = address.trim();
        }
    } else if (typeof address === "object") {
        const rawStreet = address.street || "";
        if (rawStreet.includes('|')) {
            const parts = rawStreet.split('|');
            street = (parts[0] || "").trim();
            mapUrl = (parts.slice(1).join('|') || "").trim();
        } else {
            street = rawStreet.trim();
        }
        provinceName = (address.provinceName || "").trim();
    }

    let displayText = street;
    if (provinceName && !street.toLowerCase().includes(provinceName.toLowerCase())) {
        displayText = street ? `${street}, ${provinceName}` : provinceName;
    }

    if (!mapUrl) {
        if (lat && lng) {
            mapUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
        } else if (displayText) {
            mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(displayText).replace(/%20/g, '+')}`;
        }
    }

    return {
        displayText,
        mapUrl,
    };
};

export const getBranchAddressText = (address) => {
    return parseBranchAddress(address).displayText;
};

export const getBranchMapUrl = (branch) => {
    if (!branch) return "";
    return parseBranchAddress(branch.address, branch.lat, branch.lng).mapUrl;
};

export const formatBranchAddress = (address) => {
    if (!address) return "";
    return getBranchAddressText(address);
};

export const parseAddressSetting = (rawAddress) => {
    const defaultAddress = "Số 50 Đ. Bưởi, Giảng Võ, Hà Nội, Việt Nam";
    const defaultMapUrl = "https://maps.app.goo.gl/qG3XEJiySnG13mzn9?g_st=ac";

    if (!rawAddress || typeof rawAddress !== 'string') {
        return {
            addressText: defaultAddress,
            mapUrl: defaultMapUrl,
        };
    }

    if (rawAddress.includes('|')) {
        const parts = rawAddress.split('|');
        const textPart = (parts[0] || '').trim();
        const urlPart = (parts.slice(1).join('|') || '').trim();
        return {
            addressText: textPart || defaultAddress,
            mapUrl: urlPart || defaultMapUrl,
        };
    }

    const trimmed = rawAddress.trim();
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        return {
            addressText: defaultAddress,
            mapUrl: trimmed,
        };
    }

    return {
        addressText: trimmed || defaultAddress,
        mapUrl: defaultMapUrl,
    };
};

export const getSettingAddress = (rawAddress) => {
    return parseAddressSetting(rawAddress).addressText;
};

export const getSettingMapUrl = (rawAddress) => {
    return parseAddressSetting(rawAddress).mapUrl;
};
